<template>
  <ModalShell :visible="true" :z-index="2000" @close="close" :teleport="false">
    <div class="IMC_video_box">
      <div class="imc-video-container" @click.stop>
        <div class="mgx_close_btn close_btn_pos" @click="close">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <img class="imc-img" :src="currentVideoSrc" alt="演示图片" />
      </div>
    </div>
  </ModalShell>
</template>

<script setup lang="ts">
import { isElectron } from '@libs/utils/envUtils'
import { computed } from 'vue'
import ModalShell from '../common/ModalShell.vue'

interface Emits {
  (e: 'close'): void
}

const emit = defineEmits<Emits>()

const close = () => {
  emit('close')
}

// 当前视频源
const currentVideoSrc = computed(() => {
  return isElectron() ? new URL(`../../assets/IMC.webp`, import.meta.url).href : new URL(`/src/assets/IMC.webp`, import.meta.url).href
})
</script>

<style scoped lang="less">
.IMC_video_box {
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-app-region: no-drag;
}

.imc-video-container {
  width: 1190px;
  height: 664px;
  background: #fff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-l);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: modal-in 0.4s var(--transition-base);
  overflow: hidden;
  contain: layout paint;
  will-change: transform, opacity;
}

@keyframes modal-in {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.close_btn_pos {
  position: absolute;
  top: 16px;
  right: 23px;
  z-index: 10;
}

.imc-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: var(--radius-m);
}
</style>
